import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Divider } from '@redlink/components/atoms';
import { ReportSummaryItem } from '@redlink/components/molecules';

export const ReportSummaryList = memo(({ data = [] }) => {
  const { styles } = useStyle();

  return (
    <View style={styles.bodyContainer}>
      {data
        .map((item) => (
          <ReportSummaryItem
            {...item}
            withContainer={false}
            style={styles.bodyItemContainer}
            changeTextStyle={styles.bodyItemChangeText}
          />
        ))
        .reduce((prev, current) => [prev, <Divider margin={8} />, current])}
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  bodyContainer: {},
  bodyItemContainer: {},
  bodyItemChangeText: {
    textAlign: 'left',
    marginHorizontal: 16,
  },
}));
